import {
  all,
  AllEffect,
  call,
  ForkEffect,
  put,
  takeLatest,
} from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { SplittingSuggestion } from "@stratify/shared";
import { getSplittingSuggestions } from "../api/documentsApi"; // Import API function
import { handleUpdateDocumentAddress } from "./documentAddressSaga";
import { handleUpdateCategory } from "./documentCategorySaga";
import { handleDeleteDocument } from "./documentDeletionSaga";
import {
  deleteDocumentStart,
  fetchDocumentsStart,
  fetchSuggestionsError, // Import new actions
  fetchSuggestionsStart,
  fetchSuggestionsSuccess,
  updateCategoryStart,
  updateDocumentAddressStart,
  updateDocumentStrataPlanStart,
} from "./documentsSlice";
import { handleUpdateDocumentStrataPlan } from "./documentStrataPlanSaga";
import { handleSubscriptionTask } from "./documentSubscriptionSaga";

// Saga handler for fetching splitting suggestions
function* handleFetchSuggestions(
  action: PayloadAction<string>
): Generator<any, void, any> {
  const documentId = action.payload;
  try {
    const suggestions: SplittingSuggestion[] = yield call(
      getSplittingSuggestions,
      documentId
    );
    yield put(fetchSuggestionsSuccess({ documentId, suggestions }));
  } catch (error: any) {
    yield put(
      fetchSuggestionsError({
        documentId,
        error: error.message || "Failed to fetch splitting suggestions",
      })
    );
  }
}

export function* documentsSaga(): Generator<AllEffect<ForkEffect>, void, any> {
  yield all([
    takeLatest(fetchDocumentsStart.type, handleSubscriptionTask),
    takeLatest(deleteDocumentStart.type, handleDeleteDocument),
    takeLatest(updateCategoryStart.type, handleUpdateCategory),
    takeLatest(updateDocumentAddressStart.type, handleUpdateDocumentAddress),
    takeLatest(
      updateDocumentStrataPlanStart.type,
      handleUpdateDocumentStrataPlan
    ),
    // Add watcher for fetching suggestions
    takeLatest(fetchSuggestionsStart.type, handleFetchSuggestions),
  ]);
}
